import React from 'react';
import { useTranslation } from 'react-i18next';
import PageBanner from '../layout/PageBanner';

const Legal = () => {
    const { t } = useTranslation();

    return (
        <>
            <PageBanner parentPage="Home" activePage="Legal Information" motherMenu="Legal" />

            <section className="main-legal-content" style={{ background: '#ffffff', padding: '120px 0' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div style={{ marginBottom: '40px' }}>
                                <h1 style={{ fontSize: '36px', fontWeight: '700', color: '#2c3d4f', marginBottom: '20px' }}>
                                    Legal Information
                                </h1>
                                <p style={{ color: '#5a6c7d', fontSize: '16px', marginBottom: '10px' }}>
                                    <strong>Last updated:</strong> {new Date().toLocaleDateString('en-GB')}
                                </p>
                            </div>

                            <div className="legal-content" style={{ color: '#5a6c7d', fontSize: '16px', lineHeight: '1.8' }}>
                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    1. Company Information
                                </h2>
                                <p style={{ marginBottom: '10px' }}><strong>Business Name:</strong> Pure Key Homes</p>
                                <p style={{ marginBottom: '10px' }}><strong>Location:</strong> Los Alcazares, Murcia, Spain</p>
                                <p style={{ marginBottom: '10px' }}><strong>Email:</strong> info@pure-key-homes.es</p>
                                <p style={{ marginBottom: '20px' }}><strong>Phone:</strong> +34 614 005 838</p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    2. Business Activities
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    Pure Key Homes operates as a professional property management company, providing comprehensive services for residential properties in the Costa Cálida and Costa Blanca regions of Spain. Our services include property maintenance, guest management, cleaning, key holding, and emergency response.
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    3. Professional Liability
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    Pure Key Homes maintains appropriate professional liability insurance covering our property management activities. We operate in full compliance with Spanish property management regulations and industry best practices.
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    4. Data Protection Registration
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    In accordance with the General Data Protection Regulation (GDPR) and Spanish Organic Law 3/2018 on Data Protection (LOPDGDD), Pure Key Homes is committed to protecting the personal data of our clients and their guests. We process personal data lawfully, fairly, and transparently.
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    5. Intellectual Property
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    All content on the Pure Key Homes website, including text, graphics, logos, images, and software, is the property of Pure Key Homes or its content suppliers and is protected by Spanish and international copyright laws. Unauthorized use of this content is prohibited.
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    6. Website Disclaimer
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    The information provided on this website is for general informational purposes only. While we strive to keep the information accurate and up-to-date, we make no representations or warranties of any kind about the completeness, accuracy, reliability, or availability of the website or the information contained therein.
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    7. Third-Party Links
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    Our website may contain links to third-party websites. These links are provided for your convenience only. We have no control over the content of these websites and accept no responsibility for them or for any loss or damage that may arise from your use of them.
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    8. Applicable Law and Jurisdiction
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    These legal terms are governed by and construed in accordance with Spanish law. Any disputes relating to these legal terms will be subject to the exclusive jurisdiction of the courts of Murcia, Spain.
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    9. Consumer Rights
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    As a consumer in Spain, you have specific rights under Spanish and European Union consumer protection laws. These include the right to clear information about services, fair contract terms, and access to dispute resolution mechanisms. For consumer complaints, you may contact the local consumer protection office (Oficina Municipal de Información al Consumidor).
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    10. Complaints and Dispute Resolution
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    We are committed to resolving any complaints or disputes in a fair and timely manner. If you have a complaint about our services, please contact us first at info@pure-key-homes.es or +34 614 005 838. If we cannot resolve the issue directly, you may access alternative dispute resolution procedures available under Spanish law.
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    11. Updates to Legal Information
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    We may update this legal information from time to time to reflect changes in our business practices or legal requirements. Please check this page periodically for updates.
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    12. Contact Information
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    For any legal inquiries or questions about this information, please contact:
                                </p>
                                <p style={{ marginBottom: '5px' }}><strong>Email:</strong> info@pure-key-homes.es</p>
                                <p style={{ marginBottom: '5px' }}><strong>Phone:</strong> +34 614 005 838</p>
                                <p style={{ marginBottom: '20px' }}><strong>Address:</strong> Los Alcazares, Murcia, Spain</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Legal;
